import React from 'react';

import Link from '../../library/link/link';
import Typography from '../../library/typography/typography';

import './treadwell-compact-banner.scss';

interface TreadwellCompactBannerProps {
  className?: string;
}

function TreadwellCompactBanner(props: TreadwellCompactBannerProps) {
  const { className } = props;

  return (
    <aside className={className} styleName="container">
      <div styleName="message-container">
        <img
          alt="Find tires with treadwell"
          data-testid="tire-image"
          src="https://discounttire.scene7.com/is/image/discounttire/treadwell-banner-img-spotlight?resMode=sharp2&fmt=png-alpha"
          styleName="tire-image"
        />
        <Typography styleName="message">
          Need help finding tires? Find the best tires for you
        </Typography>
      </div>
      <div styleName="link-container">
        <img
          alt="Treadwell tire gide"
          data-testid="treadwell-image"
          src="https://s7d1.scene7.com/is/image/discounttirestage/treadwell_tg-logo_small?fmt=png-alpha"
          styleName="treadwell-image"
        />
        <Link size="regular" styleName="link" to="/treadwell">
          get started
        </Link>
      </div>
    </aside>
  );
}

export default TreadwellCompactBanner;
